<style lang="scss">
.sp-form {
  .el-form-item {
    margin-bottom: 26px;
    &__error {
      position: absolute !important;
      top: 100% !important;
      left: 0 !important;
      margin-left: 0;
    }
    &.custom-error {
      .el-input__inner {
        border-color: #d9d9d9;
      }
    }
    &.is-error {
      .is-error {
        .el-input__inner {
          border-color: #f56c6c;
        }
      }
    }
    &.inline {
      display: inline-block;
      vertical-align: top;
    }
    &.no-label {
      > .el-form-item__content {
        margin-left: 0 !important;
      }
    }
  }
  &.mini {
    .el-form-item {
      margin-bottom: 10px;
    }
  }
  .el-input,
  .el-select {
    max-width: 260px;
  }
  .el-select {
    display: block;
  }
  .form-item-tip {
    font-size: 13px;
    color: #999;
    line-height: initial;
  }
  .sp-form-group {
    &:before {
      position: absolute;
      top: 11px;
      bottom: 11px;
      left: 0;
      width: 2px;
      background-color: #298dff;
      content: '';
    }
    padding: 6px 0 6px 8px;
    color: #333;
    font-weight: 500;
    font-size: 16px;
    position: relative;
    border-bottom: 1px solid #f1f2f5;
    margin-bottom: 10px;
  }
}
.en-input{
  position: relative;
  .el-input__suffix{
    right: 26px;
  }
  .el-input--suffix::after{
    content:'英';
    display: block;
    position: absolute;
    top: 0;
    color: var(--themeColor);
    right: 10px;
  }
}

.datepicker {
  .el-input__prefix {
    left: auto;
    right: 5px; /* 根据实际需要调整 */
  }
  .el-input__inner {
    padding-left: 12px;
  }
  .el-icon-time:before {
    content: '\e78e';
  }
}
</style>

<script>
import i18n from '@/i18n'
import { isFunction } from '@/utils'
import { mapGetters } from 'vuex'
import otherData from '@/i18n/locale/other'

export default {
  name: 'SpForm',
  props: {
    disabled: {
      default: false,
      type: Boolean
    },
    formList: Array,
    value: [Number, String, Object],
    size: {
      type: String,
      default: 'normal'
    },
    rest: {
      type: Boolean,
      default: true
    },
    submit: {
      type: Boolean,
      default: true
    },
    width:{
      type:String,
      default:'auto'
    },
    labelWidth: {
      type: String,
      default: '160px'
    },
    showMessage: {
      type: Boolean,
      default: false
    },
    submitText: {
      type: String,
      default: i18n.t('sp-form.index.225341-4')
    }
  },
  data() {
    // const _form = {}
    // this.formList.forEach(({ value, key }) => {
    //   _form[key] = value || ''
    // })
    // const { value } = this
    return {
      // formData: value
      localComps: []
    }
  },
  // watch: {
  //   value: {
  //     deep: true,
  //     handler(val) {
  //       this.$emit('input', val)
  //     }
  //   }
  // },
  computed: {
    ...mapGetters(['lang'])
  },
  created() {},
  methods: {
    handleCancel() {
      // this.$emit('input', false)
    },
    onSubmit() {
      this.handleSubmit().catch(() => {})
    },
    handleSubmit() {
      return new Promise((resolve, reject) => {
        this.$refs['form'].validate((valid, errField) => {
          if (valid) {
            this.$emit('input', this.value)
            this.$emit('onSubmit')
            resolve()
          } else {
            if (this.showMessage) {
              const keys = Object.keys(errField)
              const { key, validator } = this.formList.find(({ key }) => keys.includes(key))
              this.$message.error(errField[key][0].message)
            }
            reject(errField)
            // return false
          }
        })
      })
    },
    resetForm() {
      this.$refs['form'] && this.$refs['form'].resetFields()
      this.localComps.forEach((comp) => {
        comp.resetField && comp.resetField(comp.$parent.initialValue)
      })
    },
    getItemShow(item) {
      const { value } = this
      const { isShow } = item
      if (isFunction(isShow)) {
        return isShow(item, value)
      } else {
        return isShow !== false
      }
    },
    _renderTextArea(item) {
      const { value } = this
      const { placeholder, maxlength, key } = item
      return (
        <el-input
          clearable
          type='textarea'
          placeholder={placeholder || this.$t('sp-form.index.225341-0')}
          rows={5}
          maxlength={maxlength}
          v-model={value[key]}
          show-word-limit
        />
      )
    },
    _renderInput(item) {
      const { value } = this
      const { className, placeholder, append, key, maxlength, disabled = false } = item
      return (
        <el-input
          clearable
          class={className}
          type='text'
          disabled={isFunction(disabled) ? disabled() : disabled}
          maxlength={maxlength}
          showWordLimit={!!maxlength}
          placeholder={placeholder || this.$t('sp-form.index.225341-0')}
          v-model={value[key]}
        >
          <template slot='append'>{append}</template>
        </el-input>
      )
    },
    _renderDatetime(item){
      const { value } = this
      const { className, placeholder, append, key, maxlength, disabled = false } = item
      return (
        <el-date-picker
          type='datetime'
          class={{'datepicker':true,className}}
          v-model={value[key]}
          placeholder={placeholder || this.$t('sp-form.index.225341-1')}
          format='yyyy-MM-dd HH:mm:ss'
          value-format="timestamp"
        >
          <template slot='append'>{append}</template>
        </el-date-picker>
      )
    },
    _renderNumber(item) {
      const { value } = this
      const {
        className,
        placeholder,
        append,
        key,
        min = 0,
        max,
        disabled = false,
        precision = 0,
        setp = 1
      } = item
      return (
        // <el-input
        //   class={className}
        //   type='number'
        //   min={min}
        //   max={max}
        //   disabled={disabled}
        //   placeholder={placeholder || this.$t('sp-form.index.225341-0')}
        //   v-model={value[key]}
        // >
        //   <template slot='append'>{append}</template>
        // </el-input>
        <el-input-number
          v-model={value[key]}
          controls-position='right'
          min={min}
          max={max}
          precision={precision}
          setp={setp}
        />
      )
    },
    _renderText(item) {
      const { value } = this
      const { key } = item
      return <div class='el-text'>{value[key]}</div>
    },
    _renderSelect(item) {
      const { value } = this
      const { key, disabled = false, placeholder, options, clearable, onChange = () => {} } = item;
      return (
        <el-select
          disabled={isFunction(disabled) ? disabled() : disabled}
          clearable={clearable ?? true}
          filterable
          v-model={value[key]}
          placeholder={placeholder || this.$t('sp-form.index.225341-1')}
          onChange={onChange}
          disabled={disabled}
        >
          {options.map((op) => (
            <el-option key={op.value} label={op.title} value={op.value} />
          ))}
        </el-select>
      )
    },
    _renderRadio(item) {
      const { value } = this
      const { key, disabled = false, options, onChange = () => {} } = item
      return (
        <el-radio-group v-model={value[key]} onChange={onChange} disabled={disabled}>
          {options.map((op) => (
            <el-radio label={op.label}>{op.name}</el-radio>
          ))}
        </el-radio-group>
      )
    },
    _renderCheckbox(item) {
      const { value } = this
      const { key, disabled = false, options, onChange = () => {} } = item
      return (
        <el-checkbox-group v-model={value[key]} onChange={onChange} disabled={disabled}>
          {options.map((op) => (
            <el-checkbox label={op.label} disabled={op.disabled} key={op.label}>
              {op.name}
            </el-checkbox>
          ))}
        </el-checkbox-group>
      )
    },
    _renderTable(item) {
      const { value } = this
      const { key, disabled = false, options } = item
      return (
        <el-table border data={value[key]}>
          {options
            .filter((item) => item.isShow !== false)
            .map((op) => (
              <el-table-column
                prop={op.key}
                label={op.title}
                width={op.width}
                formatter={op.render}
              ></el-table-column>
            ))}
        </el-table>
      )
    },
    _renderRichText(item) {
      const { value, editorModules } = this
      const { key, disabled = false, options } = item
      return (
        <SpRichText disabled={isFunction(disabled) ? disabled() : disabled} v-model={value[key]} />
      )
    },
    _renderImage(item) {
      const { value } = this
      const { key, disabled = false, options } = item
      return <SpImage />
    },
    _renderSwitch(item) {
      const { value } = this
      const { key, onChange = () => {}, disabled, inactiveText, activeText,activeValue,inactiveValue } = item

      return (
        <el-switch
          v-model={value[key]}
          disabled={isFunction(disabled) ? disabled() : disabled}
          active-text={activeText}
          active-value={activeValue}
          inactive-value={inactiveValue}
          inactive-text={inactiveText}
          on-change={onChange}
        />
      )
    },
    _renderDatePicker(item) {
      const { value } = this
      const { key, onChange = () => {}, valueFormat, disabled = false } = item
      return (
        <el-date-picker
          disabled={disabled}
          v-model={value[key]}
          on-change={onChange}
          value-format={valueFormat}
        />
      )
    },
    labelTextFn(data) {
      if (otherData.en[data.label] && this.lang == 'en') {
        return otherData.en[data.label]
      } else {
        return data.label ? data.label + ':' : ''
      }
    },
    tipText(data) {
      if (otherData.en[data.tip] && this.lang == 'en') {
        return otherData.en[data.tip]
      } else {
        return data.tip
      }
    }
  },
  render() {
    const { title, value, formList, width, labelWidth } = this
    // console.log('sp-form value:', value)
    const localComps = []
    const getComponentByType = (item) => {
      if (typeof item.component != 'undefined') {
        const comp = item.component(item, value)
        const { context, data } = comp
        if (data && data.ref) {
          localComps.push(context.$refs[data.ref])
        }
        return comp
      }

      const renderItem = {
        'textarea': this._renderTextArea,
        'input': this._renderInput,
        'datetime': this._renderDatetime,
        'number': this._renderNumber,
        'text': this._renderText,
        'select': this._renderSelect,
        'radio': this._renderRadio,
        'checkbox': this._renderCheckbox,
        'table': this._renderTable,
        'richText': this._renderRichText,
        'image': this._renderImage,
        'switch': this._renderSwitch,
        'date-picker': this._renderDatePicker
      }
      return renderItem[item.type](item)
    }

    let rules = {}
    formList.forEach((item) => {
      if (item.validator) {
        rules[item.key] = [{ validator: item.validator }]
      } else if (item.required) {
        rules[item.key] = [
          { required: true, message: item.message || this.$t('sp-form.index.225341-2') }
        ]
      }
    })
    this.localComps = localComps
    return (
      <el-form
        size={this.size}
        ref='form'
        class={{
          'sp-form': true,
          normal: this.size == 'normal',
          min: this.size == 'min',
          width:this.width
        }}
        props={{
          model: value
        }}
        rules={rules}
        label-width={labelWidth}
        validate-on-rule-change={false}
        inline-message
      >

        {formList.map((item, index) => {
          if (item.type == 'group') {
            return (
              <div class='sp-form-group' v-show={this.getItemShow(item)}>
                {item.label}
              </div>
            )
          }else{
            return (
              <el-form-item
                label={this.labelTextFn(item)}
                prop={item.key}
                required={typeof item.required == 'undefined' ? false : item.required}
                class={[
                  item.display,
                  {
                    'no-label': typeof item.label == 'undefined',
                    'custom-error': typeof item.component != 'undefined',
                    'is-required': item.required || item.validator
                  }
                ]}
                style={{
                  width: item.width ? item.width : 'auto'
                }}
                showMessage={typeof item.showMessage == 'undefined' ? true : item.showMessage}
                v-show={this.getItemShow(item)}
              >
                {getComponentByType(item)}
                <div class='form-item-tip' domPropsInnerHTML={this.tipText(item)}></div>
              </el-form-item>
            )
          }
        })}
        {this.submit && (
          <el-form-item>
            {this.rest && (
              <el-button onClick={this.resetForm}>{this.$t('sp-form.index.225341-3')}</el-button>
            )}
            <el-button disabled={this.disabled} type='primary' onClick={this.onSubmit}>
              {this.submitText}
            </el-button>
            {this.$slots.btn}
          </el-form-item>
        )}
      </el-form>
    )
  }
}
</script>
